export const API_account_managers_list = (): string => '/api/v1/account-manager/list';
